import { forwardRef } from "react"
import { NavLink } from "react-router-dom"

const AppNavLink = ({ children, ...props }, ref) => {
  return (
    <NavLink
      {...props}
      ref={ref}
      style={({ isActive, isPending }) => {
        return {
          ...props.style,
          fontWeight: isActive ? "bold" : "",
        }
      }}
    >
      {children}
    </NavLink>
  )
}

export default forwardRef(AppNavLink)
